<template>
  <apexchart
    width="100%"
    height="300px"
    type="line"
    :options="chartOptions"
    :series="chartData"
  ></apexchart>
</template>

<script>
export default {
  props: {
    metrics: null,
  },
  computed: {
    chartData() {
      let series = [];

      for (const metricId in this.metrics) {
        let metric = this.metrics[metricId];

        let newChartData = [];

        metric.data.forEach((dataPoint) => {
          if (!isNaN(parseFloat(dataPoint.y))) {
            let newX = dataPoint.x.getTime();
            let newY = parseFloat(dataPoint.y);
            newChartData.push([newX, newY]);
          } else {
            //string is not convertable to number, insert it as an annotation
            // let newAnnotation =

            this.chartOptions = {
              ...this.chartOptions,
              ...{
                annotations: {
                  xaxis: [
                    ...this.chartOptions.annotations.xaxis,
                    {
                      x: dataPoint.x.getTime(),
                      label: { text: dataPoint.y },
                    },
                  ],
                },
              },
            };
          }
        });

        series.push({
          name: metric.name,
          data: newChartData,
        });
      }

      //   for (let metric in this.metrics) {
      //
      //   }

      return series;
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          type: "datetime",
        },
        annotations: {
          xaxis: [
            // {
            //   x: new Date().getTime(),
            //   //   strokeDashArray: 0,
            //   //   borderColor: "#775DD0",
            //   label: {
            //     // borderColor: "#775DD0",
            //     style: {
            //       //   color: "#fff",
            //       //   background: "#775DD0",
            //     },
            //     text: "Anno Test",
            //   },
            // },
          ],
        },
      },
    };
  },
};
</script>

<style></style>
